"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseNodeDescription = exports.parseNodeName = exports.parseDirectives = void 0;
function parseValueNode(node) {
    if (node.kind === "BooleanValue" ||
        node.kind === "StringValue" ||
        node.kind === "EnumValue") {
        return node.value;
    }
    if (node.kind === "IntValue" || node.kind === "FloatValue") {
        return parseFloat(node.value);
    }
    if (node.kind === "ObjectValue") {
        return {
            fields: node.fields.map((fieldNode) => ({
                name: parseNodeName(fieldNode),
                value: parseValueNode(fieldNode.value),
            })),
        };
    }
    if (node.kind === "ListValue") {
        return node.values.map(parseValueNode);
    }
    if (node.kind === "NullValue") {
        return null;
    }
    return null;
}
function parseDirectiveArguments(directiveNode) {
    return {
        fields: (directiveNode.arguments || []).map((arg) => ({
            name: parseNodeName(arg),
            value: parseValueNode(arg.value),
        })),
    };
}
function parseDirectiveNode(directiveNode) {
    return {
        name: parseNodeName(directiveNode),
        arguments: parseDirectiveArguments(directiveNode),
    };
}
function parseDirectives(node) {
    return (node.directives || []).map(parseDirectiveNode);
}
exports.parseDirectives = parseDirectives;
function parseNodeName(node) {
    return node.name.value;
}
exports.parseNodeName = parseNodeName;
function parseNodeDescription(node) {
    var _a;
    return (_a = node.description) === null || _a === void 0 ? void 0 : _a.value;
}
exports.parseNodeDescription = parseNodeDescription;
function parseCommonNode(node) {
    return {
        name: parseNodeName(node),
        description: parseNodeDescription(node),
        directives: parseDirectives(node),
    };
}
exports.default = parseCommonNode;
//# sourceMappingURL=data:application/json;base64,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